import { Category } from '@twinsketch/topika-model';
import React, { useState } from 'react';
import ApiService from 'src/services/ApiService';

export interface GenericReportPreviewModalProps {
  data: { sheetName: string; table: any[][] }[];
  fileId: string;
  fileName: string;
  workOrderId: string;
  fileCategory: Category;
  exportedSource: Set<string>;
  onClose: () => void;
}

export const GenericReportPreviewModal: React.FC<GenericReportPreviewModalProps> = ({
  data,
  fileId,
  fileName,
  workOrderId,
  fileCategory,
  exportedSource,
  onClose,
}) => {
  const [isExporting, setIsExporting] = useState<string | null>(null);

  const convertTableToText = (table: any[][]): string => {
    return JSON.stringify(table);
  };

  const handleExport = async (sheetName: string, excelText: string) => {
    try {
      setIsExporting(sheetName);
      await ApiService.parseWorkReport(workOrderId, fileId, sheetName, fileCategory, excelText);
      alert(`Exported sheet: ${sheetName}`);

      // Redirect to the appropriate page after successful export
      window.location.href = `http://localhost:3000/work-orders/${workOrderId}/files`;
    } catch (err) {
      console.error('Export failed', err);
      alert(`Failed to export sheet: ${sheetName}`);
    } finally {
      setIsExporting(null);
    }
  };

  return (
    <div
      className="modal"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'transparent',
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: 'white',
          padding: '20px',
          width: '60%',
          maxHeight: '85%',
          overflowY: 'auto',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          position: 'relative',
        }}
      >
        <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: '24px',
              fontWeight: 'bold',
              cursor: 'pointer',
              color: '#666',
            }}
          >
            ×
          </button>
        </div>

        <div style={{ marginTop: '40px' }}>
          <h3 style={{ marginBottom: '10px' }}>{fileName}</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {data.map(sheet => {
              const excelText = convertTableToText(sheet.table);
              const key = `${fileId}-${sheet.sheetName}`;
              const alreadyExported = exportedSource.has(key);

              return (
                <div
                  key={sheet.sheetName}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <span style={{ fontSize: '16px' }}>{sheet.sheetName}</span>
                  <button
                    onClick={() => handleExport(sheet.sheetName, excelText)}
                    disabled={alreadyExported || isExporting === sheet.sheetName}
                    style={{
                      padding: '4px 10px',
                      fontSize: '13px',
                      backgroundColor: alreadyExported ? '#aaa' : '#4CAF50',
                      color: 'white',
                      border: 'none',
                      cursor: alreadyExported ? 'not-allowed' : 'pointer',
                    }}
                  >
                    {alreadyExported
                      ? 'Already Exported'
                      : isExporting === sheet.sheetName
                        ? 'Exporting...'
                        : 'Export'}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
